<template>
  <span class="progress-bar" :style="'width:' + ratio + '%;'"></span>
</template>

<script>
export default {
  props: ['data'],
  computed: {
    ratio () {
      if (this.data) {
        let ratio = Number(this.data)
        if (ratio < 1) {
          if (ratio < 0.05) {
            return 5
          } else if (ratio <= 0.99 && ratio >= 0.96) {
            return 96
          }
        }
        return ratio * 100
      }
      return 0
    }
  }
}
</script>
<style scoped>
  .progress-bar {
    display: block;
    height: 100%;
    background-color: #1351f9;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#5654e1",endColorstr="#2ac5fe",gradientType=1);
  }
</style>
